export const APP_CONFIG = {
    URL: {
      apiBasePath: location.origin,
    },
  };
  
export const getHeaders = () => {
  return {
    "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  }
}